import { IMayHaveBoundry, IMustHaveClickEvent } from '../../abstracts/gmaps/gmarker.abstract'
import { GMarkerLabel } from '../../models/gmaps/gmarker-label.model'

export class GMarker implements IMustHaveClickEvent{
    
    
    id: number;
    title: string;
    position: any;
    icon: any;
    label : GMarkerLabel = null

	animation?: google.maps.Animation
    hasClickEvent: boolean;

}
